import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AlertService } from '../alert.service';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'tea-shop-fe-contact',
  standalone: false,
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css'
})
export class ContactComponent {
  contactForm: FormGroup;
  submitted = false;

  contactUsWorkflowUrl = environment.contactUsWorkflowUrl;

  subjects = [
    { value: 'General Inquiry', label: 'General Inquiry' },
    { value: 'Product Question', label: 'Product Question' },
    { value: 'Shipping & Delivery', label: 'Shipping & Delivery' },
    { value: 'Other', label: 'Other' }
  ];

  private validateSubject(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return { required: true };
    
    const validSubject = this.subjects.some(subject => subject.value === value);
    return validSubject ? null : { invalidSubject: true };
  }

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private alertService: AlertService,
    private metaDataService: MetaDataService,
    private logger: NGXLogger,
  ) {
    this.metaDataService.updateMetadata({
      title: 'Contact Us',
      image: '/assets/contact/sencha-logo.png',
    });
    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', [Validators.required, this.validateSubject.bind(this)]],
      message: ['', Validators.required]
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.contactForm.valid) {
      this.http.post(this.contactUsWorkflowUrl, this.contactForm.value)
        .subscribe({
          next: (response) => {
            this.logger.log('Form submitted successfully', response);
            this.contactForm.reset();
            this.submitted = false;
            this.alertService.show({
              title: 'Contact Form Submitted',
              description: 'Thank you for reaching out to us. We will get back to you as soon as possible.',
              type: 'success',
              duration: 5000,
            });
          },
          error: (error) => {
            this.logger.error('Error submitting form', error);
            this.alertService.show({
              title: 'Contact Form Error',
              description: 'There was an error submitting the form. Please try again soon, or email contact@sencha-tea.com',
              type: 'error',
              duration: 5000
            });
          }
        });
    } else {
      this.alertService.show({
        title: 'Contact Form Error',
        description: 'Please review the form and try again.',
        type: 'error',
        duration: 5000
      });
    }
  }
}
